import React, { useEffect, useRef } from "react";
import { X, Loader2, PlayCircle } from "lucide-react";

// Plays a TikTok explainer video inside a clean portrait card modal.
const VideoModal = ({ open, onClose, videoId, title }) => {
  const frameRef = useRef(null);

  // Ask the TikTok player to play with sound once it's ready.
  useEffect(() => {
    if (!open) return undefined;
    const send = (type) => frameRef.current?.contentWindow?.postMessage({ type, "x-tiktok-player": true }, "*");
    let done = false;
    const onMsg = (e) => {
      if (done || e.source !== frameRef.current?.contentWindow) return;
      let d = e.data;
      if (typeof d === "string") { try { d = JSON.parse(d); } catch { return; } }
      if (d?.type === "onPlayerReady" || (d?.type === "onStateChange" && d?.value === 1)) { send("unMute"); send("play"); }
      if (d?.type === "onMute" && d?.value === false) done = true;
    };
    window.addEventListener("message", onMsg);
    return () => window.removeEventListener("message", onMsg);
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[110] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-[#06160f]/85 backdrop-blur-sm" onClick={onClose} />

      <div className="pop-in relative w-full max-w-[380px] overflow-hidden rounded-3xl bg-white shadow-2xl">
        {/* Header */}
        <div className="flex items-center justify-between gap-3 bg-[#1B4332] px-5 py-4">
          <div className="flex items-center gap-2 text-white">
            <PlayCircle size={20} className="text-[#95D5B2]" />
            <p className="font-display text-sm font-semibold uppercase tracking-wider">
              {title || "What is it & its benefits"}
            </p>
          </div>
          <button
            onClick={onClose}
            aria-label="Close video"
            className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white/15 text-white transition hover:bg-white/30"
          >
            <X size={17} />
          </button>
        </div>

        {/* Video */}
        <div className="relative w-full bg-black" style={{ aspectRatio: "9 / 16" }}>
          <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 text-white/70">
            <Loader2 size={28} className="animate-spin" />
            <span className="text-xs">Loading video…</span>
          </div>
          <iframe
            title="Supplement explainer video"
            ref={frameRef}
            src={`https://www.tiktok.com/player/v1/${videoId}?autoplay=1&rel=0&music_info=0&description=0`}
            className="absolute inset-0 h-full w-full"
            frameBorder="0"
            scrolling="no"
            allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
            allowFullScreen
          />
        </div>

        <div className="bg-white px-5 py-3 text-center">
          <p className="text-xs text-[#8aa093]">Clean, high-strength &amp; nasty free · Made in the UK</p>
        </div>
      </div>
    </div>
  );
};

export default VideoModal;
